'use client';

import React, { useEffect, useState } from 'react';

import Script from 'next/script';

import ReCaptchaContext from '@/contexts/ReCaptchaContext';
import { useEnvContext } from '@/helpers/envUtils';

interface ReCaptchaContextType {
  isLoaded: boolean;
  sitekey: string;
  scoredBasedKey: string;
}

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    onloadReCaptchaCallback: () => void;
  }
}

const RECAPTCHA_V2_SCRIPT_URL =
  'https://www.google.com/recaptcha/enterprise.js?onload=onloadReCaptchaCallback&render=explicit';

const ReCaptchaWrapper = ({ children }: { children: React.ReactNode }) => {
  const { RECAPCHA_KEY, RECAPTCHA_SCORE_BASED_KEY, RECAPTCHA_SCRIPT_URL: SCORE_BASED_SCRIPT_URL } = useEnvContext();
  const [reCaptchaContext, setReCaptchaContext] = useState<ReCaptchaContextType>({
    isLoaded: false,
    sitekey: RECAPCHA_KEY,
    scoredBasedKey: RECAPTCHA_SCORE_BASED_KEY,
  });

  useEffect(() => {
    window.onloadReCaptchaCallback = () => {
      setReCaptchaContext({ sitekey: RECAPCHA_KEY, scoredBasedKey: RECAPTCHA_SCORE_BASED_KEY, isLoaded: true });
    };
  }, [reCaptchaContext, setReCaptchaContext, RECAPCHA_KEY, RECAPTCHA_SCORE_BASED_KEY]);

  return (
    <ReCaptchaContext.Provider value={reCaptchaContext}>
      <Script src={RECAPTCHA_V2_SCRIPT_URL} async defer />
      <Script src={SCORE_BASED_SCRIPT_URL} async defer />
      {children}
    </ReCaptchaContext.Provider>
  );
};

export default ReCaptchaWrapper;
